import MegaphoneModal from '../../Components/MegaphoneModal/MegaphoneModal';
import LicenseSetting from './LicenseSettings';
import styles from "../../Pages/UserManagement/UserManagement.module.scss";
import React from 'react';
import meetingCardImg from "../../Image/meeting-card-img.png";
import virtualOfficeImg from "../../Image/virtual-office.png";
import voiceCardImg from "../../Image/voicemail-card-img.png";
import aiUsersImg from "../../Image/ai-users-card-img.png";
import smsImg from "../../Image/sms-card-img.png";
import UserLicensesTable from './UserLicensesTable';
import wilineLogo from "../../Image/logo-blue.png";
import { useLicenseSettings } from './LicenseSettingsContext';
import { CustomerLicense } from '../../Utils/types';
import { isAiUsersLicense } from './utils/licenseType';


interface LicenseSettingsModalProps {
  licenseSettings?: CustomerLicense;
  type: string;
  loading?: boolean;
}

interface IconMap {
  [key: string]: string;
}

const iconMap: IconMap = {
  MeetingLicense: meetingCardImg,
  Voicemail: voiceCardImg,
  SMSLicense: smsImg,
  VirtualOffice: virtualOfficeImg,
  AIUsers: aiUsersImg
};

const LicenseEditor: React.FC<LicenseSettingsModalProps> = ({
  licenseSettings,
  type,
}) => {
  const {visible, toggleVisible, forceUpdate} = useLicenseSettings();
  const [transferOccurred, setTransferOccurred] = React.useState(false);
  const aiUsersLicense = isAiUsersLicense(type);

  const handleClose = () => {
    toggleVisible(false);
    if(transferOccurred && type.includes("UCaaS")){
      forceUpdate();
      setTransferOccurred(false);
    }
  }

  const handleLicenseTransfer = () => {
    setTransferOccurred(true);
  }

  const modalIcon = React.useMemo(() => {
    if (aiUsersLicense) {
      return aiUsersImg;
    }
    const normalizedType = type.replace(/\s/g, "");
    return iconMap[normalizedType] ?? wilineLogo;
  }, [aiUsersLicense, type]);

  return (
    <MegaphoneModal
      modalKey="licenseEditor"
      title={type}
      icon={modalIcon}
      visible={visible}
      onClose={handleClose}
      closable={true}
      width={800}
      footer={null}
      customClassNames={{ body: styles.modalBody }}
    >
      <>
          <LicenseSetting settings={licenseSettings} licenseName={type}/>
          <UserLicensesTable
            isVisible={visible}
            value={licenseSettings?.value!!}
            currentCustomerLicenseId={licenseSettings?.id!!}
            type={type}
            onLicenseTransfer={handleLicenseTransfer}
            isAiUsersLicense={aiUsersLicense}
          />
      </>
    </MegaphoneModal>
  );
}

export default LicenseEditor;